/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcMfrecoV1PositionDayState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_MFRECO_V1_POSITION_DAY_STATE_ENTITY_NAME = 'ixc.mfreco.v1.PositionDay';
export const ixcMfrecoV1PositionDayStateEntity = new schema.Entity<IxcMfrecoV1PositionDayState>(IXC_MFRECO_V1_POSITION_DAY_STATE_ENTITY_NAME, {}, { idAttribute: (entity: IxcMfrecoV1PositionDayState) => `${entity.venue}-${entity.assetId}-${entity.date}` });

